// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-label{left:.9rem;top:.6rem}.bw-field{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:1rem 0 0 .8rem;height:3.5rem;background-image:url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.941 8l1.057 1.065L12.005 18 3.002 9.065 4.058 8l7.947 7.886z\" fill=\"rgba(12,2,67,1)\" fill-rule=\"evenodd\"/></svg>');background-size:24px;background-position:center right;background-position-x:calc(100% - 16px);background-repeat:no-repeat;line-height:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "bw-label",
	"field": "bw-field"
};
module.exports = ___CSS_LOADER_EXPORT___;
